import React, { useCallback, useContext, useState } from "react";
import { NotificationsContext } from "../../Notifications";
import { useIntl, FormattedMessage } from "react-intl";
import apiRequest from "../../../services/apiRequest";

import Input from "../../Input";
import Modal from "../../Modal";
import Button from "../../Button";
import Placeholder from "../../Placeholder";

import usePolicies from "../Roles/Hooks/usePolicies";
import SelectPolicies from "../Roles/SelectPolicies";

function AddGroupDialog({ open, toggleOpen, groups, setGroups }) {
  const intl = useIntl();
  const [loading, setLoading] = useState(false);
  const policies = usePolicies();
  const [name, setName] = useState("");
  const [scopes, setScopes] = useState([]);
  const { push } = useContext(NotificationsContext);

  const _onSubmit = useCallback(
    async (e) => {
      try {
        e.preventDefault();

        if (!name) {
          return;
        }

        setLoading(true);
        const data = await apiRequest.post("/groups", {
          name,
          scopes: scopes.join(";"),
        });
        setGroups({ ...groups, [data.id]: data });
        toggleOpen();
        push({
          title: intl.formatMessage({ id: "role_created_successfully" }),
          type: "success",
        });
      } catch (error) {
        push({
          title: intl.formatMessage({ id: "role_already_used" }),
          type: "error",
        });
      } finally {
        setLoading(false);
      }
    },
    [name, toggleOpen, scopes, push, intl]
  );

  if (!open) {
    return null;
  }

  return (
    <div>
      <Modal onExit={toggleOpen}>
        <div className="m-8">
          <h3 className="text-center text-2xl font-extrabold text-black-500">
            <FormattedMessage id="add_group" />
          </h3>
        </div>

        <form id="add-group-form" onSubmit={_onSubmit}>
          <div>
            <Input
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
              label={intl.formatMessage({ id: "group_name" })}
              type="text"
              errorMessage={intl.formatMessage({ id: "add_group_name" })}
              required
            />
          </div>

          <div className="mb-6">
            {policies ? (
              <SelectPolicies
                policies={policies}
                scopes={scopes}
                setScopes={setScopes}
              />
            ) : (
              <div>
                <Placeholder width="w-4/5" />
                <Placeholder width="w-3/5" />
              </div>
            )}
          </div>

          <div className="mt-4 flex items-end justify-end">
            <Button submitting={loading} type="submit">
              <FormattedMessage id="add" />
            </Button>
          </div>
        </form>
      </Modal>
    </div>
  );
}

export default AddGroupDialog;
